export default "__VITE_ASSET__32f526c3__"